module.exports = __webpack_public_path__ + "img/banner_2.6d1112f8.svg";